import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./Styles.css";
import { withTranslation } from "react-i18next";

class SmallStats extends React.Component {
  handleClick = () => {
    const { state, onClick } = this.props;
    if (onClick) {
      onClick(state); // 🔥 send state back to parent
    }
  };

  handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.handleClick();
    }
  };

  render() {
    const { t } = this.props;

    const {
      state,
      icon,
      value,
      tone,
      onClick
    } = this.props;

    const RSBHeader = classNames(
      state === `${t("Critical")}`
        ? "critical"
        : state === `${t("Optimal")}`
        ? "optimal"
        : state === `${t("Full")}`
        ? "full"
        : null
    );

    return (
      <div
        onClick={this.handleClick}
        onKeyDown={this.handleKeyDown}
        className={classNames("statsBox", tone && `statsBox--${tone}`)}
        role={onClick ? "button" : undefined}
        tabIndex={onClick ? 0 : undefined}
        style={{ cursor: onClick ? "pointer" : "default" }}
      >
        <div
          className={RSBHeader}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}
        >
          <h2 className={RSBHeader}>{value}</h2>
          <span>{state}</span>
          <p style={{ textAlign: "center" }} className={RSBHeader}>
            {icon}
          </p>
        </div>
      </div>
    );
  }
}

SmallStats.propTypes = {
  state: PropTypes.string,
  icon: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onClick: PropTypes.func,
  tone: PropTypes.string
};

SmallStats.defaultProps = {
  icon: "",
  state: "State",
  value: 0,
  onClick: null,
  tone: ""
};

export default withTranslation()(SmallStats);
